import { render, staticRenderFns } from "./DomainManagement.vue?vue&type=template&id=5b0e799a"
import script from "./DomainManagement.vue?vue&type=script&lang=js"
export * from "./DomainManagement.vue?vue&type=script&lang=js"
import style0 from "./DomainManagement.vue?vue&type=style&index=0&id=5b0e799a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports